import { jsx as r } from "react/jsx-runtime";
import c from "react";
import { _ as m } from "../../../cs-Dfox81s-.js";
import "../../../type-Dku6Xzl6.js";
import p from "../../../contexts/tab.js";
import '../../../index68.css';const f = "_tab-panel_x2apo_1", _ = "_with-contents-only_x2apo_2", t = {
  tabPanel: f,
  withContentsOnly: _
};
function w(n) {
  const e = c.useContext(p), {
    name: o,
    elementRef: a,
    withContentsOnly: s,
    className: l,
    ...i
  } = n;
  return e.activeTab === o ? /* @__PURE__ */ r(
    "div",
    {
      ...i,
      className: m(
        t.tabPanel,
        s && t.withContentsOnly,
        l
      ),
      role: "tabpanel",
      ref: a
    }
  ) : null;
}
export {
  w as default
};
